import React from 'react';
import { motion } from 'framer-motion';
const events = [{
  id: 1,
  date: 'JAN 23',
  title: 'AFTER HOURS',
  artist: 'NOMADIQ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY'
}, {
  id: 2,
  date: 'JAN 24',
  title: 'AFTER HOURS',
  artist: 'DJ NINO',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1571266028243-371695039989?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY'
}, {
  id: 3,
  date: 'JAN 25',
  title: 'INDUSTRY SUNDAY',
  artist: 'DJ KILOO',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY'
}, {
  id: 4,
  date: 'JAN 29',
  title: "DRINK DANCE DRAI'S",
  artist: 'DJ MARX',
  time: '10PM',
  image: 'https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?q=80&w=1000&auto=format&fit=crop',
  type: 'THURSDAY'
}, {
  id: 5,
  date: 'JAN 30',
  title: 'AFTER HOURS',
  artist: 'DJ POUN',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY'
}, {
  id: 6,
  date: 'JAN 31',
  title: 'AFTER HOURS',
  artist: 'DJ ROMEO',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY'
}, {
  id: 7,
  date: 'FEB 1',
  title: 'INDUSTRY SUNDAY',
  artist: 'GUEST DJ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1514525253440-b393452e8d26?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY'
}, {
  id: 8,
  date: 'FEB 5',
  title: 'LADIES NIGHT',
  artist: 'SPECIAL GUEST',
  time: '10PM',
  image: 'https://images.unsplash.com/photo-1545128485-c400e7702796?q=80&w=1000&auto=format&fit=crop',
  type: 'THURSDAY'
}, {
  id: 9,
  date: 'FEB 6',
  title: 'AFTER HOURS',
  artist: 'RESIDENT DJ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY'
}, {
  id: 10,
  date: 'FEB 7',
  title: 'AFTER HOURS',
  artist: 'RESIDENT DJ',
  time: '1AM',
  image: 'https://images.unsplash.com/photo-1516280440614-6697288d5d38?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY'
}, {
  id: 11,
  date: 'FEB 8',
  title: 'BIG GAME',
  artist: 'WATCH PARTY',
  time: '2PM',
  image: 'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY'
}];
export function EventsGridView() {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-212">
      {events.map((event, index) => <motion.div key={event.id} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.05,
      duration: 0.4
    }} className="group relative bg-[#0B1014] border border-white/10 hover:border-[#DDA247] transition-all duration-300 overflow-hidden cursor-pointer" data-id="element-213">
          {/* Image */}
          <div className="relative h-80 overflow-hidden" data-id="element-214">
            <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-215" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-216" />

            {/* Content Overlay */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 text-center" data-id="element-217">
              <div className="bg-[#DDA247] text-[#0B1014] px-3 py-1 text-xs font-bold uppercase tracking-wider mb-3 inline-block self-center" data-id="element-218">
                {event.type}, {event.date}
              </div>
              <h3 className="text-white font-bold text-xl mb-2 uppercase tracking-wide" data-id="element-219">
                {event.title}
              </h3>
              <p className="text-white text-2xl font-bold mb-2" data-id="element-220">
                {event.artist}
              </p>
              <p className="text-gray-400 text-sm tracking-wider" data-id="element-221">
                {event.time}
              </p>

              {/* Hover CTA */}
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileHover={{
            opacity: 1,
            y: 0
          }} className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-222">
                <button className="bg-[#DDA247] text-[#0B1014] px-6 py-2 text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors" data-id="element-223">
                  Buy Tickets
                </button>
              </motion.div>
            </div>
          </div>
        </motion.div>)}
    </div>;
}